function isNotNumber(value: any) {
  return (
    typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)
  );
}

/**
 * Attempts to parse the argument as a (floating point) number.
 * Returns `0` if parsing fails.
 */
export function toNumber(value: any) {
  const num = parseFloat(value);
  return isNotNumber(num) ? 0 : num;
}

/**
 * Rounds a number to a specific precision (decimal places). Returns a
 * string representing a number in fixed-point notation.
 */
export function toPrecision(value: number, precision = 4) {
  const scaleFactor = 10 ** precision;
  let nextValue = toNumber(value);

  nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;

  return nextValue.toFixed(precision);
}

/**
 * Counts the number of decimal places a number has. Trailing zeros
 * are *not* included in the count.
 */
export function countDecimalPlaces(value: number) {
  if (!Number.isFinite(value)) return 0;

  let e = 1;
  let p = 0;

  while (Math.round(value * e) / e !== value) {
    e *= 10;
    p += 1;
  }

  return p;
}

/**
 * Get the number of decimal places in either `value` or `step`,
 * whichever is greater. Trailing zeros are not counted.
 */
export function getNumDecimalPlaces(value: number, step: number) {
  return Math.max(countDecimalPlaces(step), countDecimalPlaces(value));
}

/**
 * Clamps a number to ensure it stays within a min and max range.
 */
export function clampValue(value: number, min: number, max: number) {
  if (value == null || (isNotNumber(min) && isNotNumber(max))) return value;

  if (isNotNumber(min)) return Math.min(value, max);
  if (isNotNumber(max)) return Math.max(value, min);

  return Math.min(Math.max(value, min), max);
}
